import { BRAND } from "constants/brand";
import "./home.scss";
import useHome from "hooks/useHome";
import { useEffect, useState } from "react";
import { Ring } from "@uiball/loaders";
import { useSelector } from "react-redux";
import Alerts from "./Alerts/Alert";
import AppVersions from "./AppVersions/AppVersions";

const Setting = () => {
    const [data, setData] = useState();
    const { loading, fetchAlerts } = useHome();
    // const statusForm = useRef();
    // const alertForm = useRef();
    // const pointsForm = useRef();
    const isSuperAdmin = Boolean(useSelector((state) => state.auth.userData)?.super_admin);
    // const [seleteddialogCities, setSelectedDialogCities] = useState([]);

    const fetchNumbers = async () => {
        try {
            const response = await fetchAlerts();

            // setSelectedAlertCities(response.alert.cities.map((c) => c.id));
            // setSelectedDialogCities(response.app_status.cities.map((c) => c.id));

            setData(response);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchNumbers();
    }, []);

    // const statusSubmitHandler = async (e) => {
    //   e.preventDefault();
    //   const alertData = new FormData();

    //   seleteddialogCities.forEach((c) => {
    //     alertData.append("cities[]", c);
    //   });
    //   alertData.append("name", "app_status");
    //   alertData.append("content", statusForm.current[0].value);
    //   alertData.append("active", statusForm.current[1].checked);

    //   try {
    //     await updateAlertsContent(alertData);
    //     fetchNumbers();
    //     showMessage("success", "تم التعديل", "تم التعديل بنجاح");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    // const pointsSubmitHandler = async (e) => {
    //   e.preventDefault();

    //   const alertData = new FormData();

    //   alertData.append("name", "points");
    //   alertData.append("content", pointsForm.current[0].value);
    //   alertData.append("active", pointsForm.current[1].checked);
    //   try {
    //     await updateAlertsContent(alertData);
    //     fetchNumbers();
    //     showMessage("success", "تم التعديل", "تم التعديل بنجاح");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    return (
        <div className="settings">
            {loading ? (
                <div className="loadingSpinner center">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <Alerts title="التنبيه" data={data?.alert} fetchNumbers={fetchNumbers} />
                    <Alerts title="الاغلاق" data={data?.app_status} fetchNumbers={fetchNumbers} />

                    {/* Super admins only. `min_version` is the force-update
                        gate every mobile build checks at launch: set above the
                        build actually live on the store and the whole fleet is
                        locked out of an app it cannot install, for as long as
                        review takes. التنبيه and الاغلاق, which share this
                        page, are ordinary admin work — one of them is how you
                        stop ordering in a hurry — so the gate belongs here on
                        the section and not on the route. PUT /api/app-versions/:app enforces the same
                        rule server-side — this only stops the dashboard
                        offering what the API will refuse. */}
                    {isSuperAdmin ? <AppVersions /> : null}
                </>
            )}
        </div>
    );
};
export default Setting;
